import { render } from "./UsadosPage.vue?vue&type=template&id=380408fc&scoped=true"
import script from "./UsadosPage.vue?vue&type=script&lang=js"
export * from "./UsadosPage.vue?vue&type=script&lang=js"

import "./UsadosPage.vue?vue&type=style&index=0&id=380408fc&lang=scss&scoped=true"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380408fc"]])

export default __exports__